<a class="button-component"
  [ngClass]="getButtonClass()"
   [ngStyle]="{
    'width': width,
   'max-height': hasSvgIcon ? '100%' : null,
   'background-color': color || null,
   'color': textColor || null
   }">

  <!-- Icon on the left (Non-SVG) -->
  @if (iconPosition === 'left' && !hasSvgIcon && icon) {
    <mat-icon
      [style.fontSize]="iconSize"
      [style.width]="iconSize"
      [style.height]="iconSize"
      [style.color]="iconColor"
      [ngStyle]="{'margin-right': '10px'}">
      {{ icon }}
    </mat-icon>
  }

  <!-- SVG Icon -->
  @if (hasSvgIcon) {
    <img src="{{ icon }}" alt="Icon" [ngClass]="addIconClasses ? 'svg-icon' : 'svg-icon-size'">
  }

  <!-- Message -->
  @if (message) {
    {{ message }}
  } @else {
    <ng-content></ng-content>
  }

  <!-- Icon on the right (Non-SVG) -->
  @if (iconPosition === 'right' && !hasSvgIcon && icon) {
    <mat-icon
      [style.fontSize]="iconSize"
      [style.width]="iconSize"
      [style.height]="iconSize"
      [style.color]="iconColor"
      [ngStyle]="{'margin-left': '10px'}">
      {{ icon }}
    </mat-icon>
  }
</a>
